/* eslint-disable no-nested-ternary */

import ReactDom from 'react-dom';

import { Icon as BlueIcon } from '@blueprintjs/core';

import { State } from '@hookstate/core';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { deleteTags } from '@services/queries/tags/deleteTags/deleteTags';
import { indexTagsCategory } from '@services/queries/tagsCategory';
import { ITag } from '@models/Tag.model';
import { trackDeletedTags } from '@services/mixpanel/trackers/TagsMetrics';
import {
  Container,
  Overlay,
  Delete,
  Cancel,
  Buttons,
  Header,
  Text,
  RowDiv,
  CloseButton,
  // Bold,
  RedBold,
} from './Deletedialog.styles';

interface OwnProps {
  open: State<boolean>;
  onDelete: () => void;
  tagsIds: string[];
  selectedTags: ITag[];
}

export const DeleteDialog = ({
  open,
  tagsIds,
  onDelete,
  selectedTags,
}: OwnProps) => {
  const portalDiv = document.getElementById('portal');
  const queryClient = useQueryClient();

  const { data } = useQuery(['tagsCategory'], () => indexTagsCategory());

  const newData = data ?? [];

  const categoriesCount = newData
    .map(tagCategories => {
      const validTags = selectedTags.filter(
        tag => tag.tagCategoryId === tagCategories.id,
      );
      if (validTags.length === 0) return undefined;
      const tagGroup = { tagCategories, validTags };
      return tagGroup;
    })
    .filter(tagGroup => !!tagGroup);

  const affectedCategoriesNames = categoriesCount.map(e =>
    e ? e.tagCategories.name : '',
  );

  const mutationDeleteTags = useMutation(deleteTags, {
    onSuccess: () => {
      queryClient.invalidateQueries(['tags']);
      queryClient.invalidateQueries(['tagCategories']);
      trackDeletedTags(
        tagsIds.length,
        categoriesCount.length,
        affectedCategoriesNames,
      );
      open.set(false);
      onDelete();
    },
  });

  return open.get() && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            <RowDiv
              onClick={() => {
                open.set(false);
              }}
            >
              <Header>Are you sure?</Header>
              <CloseButton>
                <BlueIcon icon="cross" color="#8F95B2" />
              </CloseButton>
            </RowDiv>
            <Text>
              You&apos;re about to permanently delete{' '}
              <RedBold>{`${tagsIds.length} tags`}</RedBold>.
              {/* , being used by{' '}
              <Bold># assets</Bold>. */}
            </Text>

            <Buttons>
              <Cancel
                onClick={() => {
                  open.set(false);
                }}
              >
                Cancel
              </Cancel>

              <Delete
                disabled={mutationDeleteTags.isLoading}
                onClick={() => {
                  mutationDeleteTags.mutate({ tagsIds });
                }}
              >
                Delete
              </Delete>
            </Buttons>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
